import { Link } from 'react-router-dom';

function CASB() {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        {/* Hero */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <span className="inline-block px-4 py-2 bg-cyber-purple/20 text-cyber-purple rounded-full text-sm font-semibold mb-4">
            CLOUD ACCESS SECURITY BROKER
          </span>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="gradient-text">Comprehensive SaaS</span>
            <br />
            <span className="text-white">Security Platform</span>
          </h1>
          <p className="text-xl text-gray-400 mb-8">
            Visibility, compliance, and threat protection for all your cloud applications.
          </p>
          <Link to="/contact" className="btn-primary text-lg">
            Request Demo
          </Link>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Shadow IT Discovery</h3>
            <p className="text-gray-400">
              Identify and manage all cloud services in use across your organization.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Data Loss Prevention</h3>
            <p className="text-gray-400">
              Prevent sensitive data from leaving your organization through cloud apps.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Threat Protection</h3>
            <p className="text-gray-400">
              Real-time detection and blocking of malware, ransomware, and anomalous activity.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Compliance Monitoring</h3>
            <p className="text-gray-400">
              Continuous compliance checks for GDPR, HIPAA, SOC 2, and more.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Access Control</h3>
            <p className="text-gray-400">
              Granular policies to control who can access what, from where, and when.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">API Integration</h3>
            <p className="text-gray-400">
              Deep integration with 100+ SaaS applications for comprehensive protection.
            </p>
          </div>
        </div>

        {/* Supported Apps */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-center mb-12">
            <span className="gradient-text">Integrated with Your Favorite Apps</span>
          </h2>
          <div className="flex flex-wrap justify-center gap-8 items-center">
            {['Microsoft 365', 'Google Workspace', 'Salesforce', 'Slack', 'Zoom', 'Dropbox', 'Box', 'GitHub'].map((app) => (
              <div key={app} className="px-6 py-3 bg-cyber-dark border border-gray-800 rounded-lg text-gray-400 hover:border-cyber-purple hover:text-white transition-all">
                {app}
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="card text-center bg-gradient-to-r from-cyber-purple/10 to-cyber-pink/10">
          <h2 className="text-3xl font-bold mb-4 text-white">Secure Your Cloud Applications Today</h2>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            Get complete visibility and control over your SaaS environment.
          </p>
          <Link to="/contact" className="btn-primary">
            Contact Sales
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CASB;
